var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#010101;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{display:inline;fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st5{font-family:'MyriadPro-Bold';}\r\n\t.st6{font-size:18.8696px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000014636207398946224000000001616234316485684116_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 0.8,
    className: "st2",
    width: 19.8,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 0.8,
    className: "st2",
    width: 19.8,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 2.7,
    className: "st3",
    width: 16.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2.7,
    className: "st3",
    width: 16.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25.7,
    className: "st3",
    width: 6.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25.7,
    className: "st3",
    width: 6.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3.9,25.7 9.6,25.7 15.8,31.9 23.7,31.9 23.7,34.2 14.9,34.2 8.5,27.8 3.9,27.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3.9,32.6 9.7,32.6 15.9,38.8 23.7,38.8 23.7,41 14.9,41 8.5,34.6 3.9,34.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "44.5,32.6 38.8,32.6 32.6,38.8 24.7,38.8 24.7,41 33.5,41 39.9,34.6 44.5,34.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "44.5,25.7 38.8,25.7 32.6,31.9 24.7,31.9 24.7,34.2 33.5,34.2 39.9,27.8 44.5,27.8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 21.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M7.9,29.6V17.4h9v2.1h-6.6v2.7h6.1v2.1h-6.1v3.3h6.8v2.1H7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M19.3,17.4h4.9c1,0,1.7,0,2.2,0.1c0.5,0.1,0.9,0.2,1.3,0.5c0.4,0.3,0.7,0.6,0.9,1c0.2,0.4,0.4,0.9,0.4,1.4 c0,0.6-0.2,1.1-0.5,1.6c-0.3,0.5-0.7,0.8-1.2,1.1c0.7,0.2,1.3,0.6,1.7,1.1c0.4,0.5,0.6,1.1,0.6,1.8c0,0.6-0.1,1.1-0.4,1.6 c-0.3,0.5-0.6,0.9-1.1,1.3s-1,0.5-1.6,0.6c-0.4,0-1.4,0.1-3,0.1h-4.1V17.4z M21.7,19.5v2.8h1.6c1,0,1.6,0,1.8,0 c0.4,0,0.8-0.2,1-0.4c0.2-0.2,0.4-0.6,0.4-1c0-0.4-0.1-0.7-0.3-0.9c-0.2-0.2-0.5-0.4-0.9-0.4c-0.2,0-0.9,0-2.1,0H21.7z M21.7,24.3 v3.3H24c0.9,0,1.4,0,1.7-0.1c0.4-0.1,0.7-0.2,0.9-0.5c0.2-0.3,0.3-0.6,0.3-1c0-0.4-0.1-0.7-0.3-0.9c-0.2-0.3-0.4-0.4-0.8-0.6 c-0.3-0.1-1.1-0.2-2.2-0.2H21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M30.9,25.7l2.4-0.2c0.1,0.8,0.4,1.4,0.9,1.8c0.4,0.4,1,0.6,1.8,0.6c0.8,0,1.4-0.2,1.8-0.5 c0.4-0.3,0.6-0.7,0.6-1.2c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.4-0.9-0.5c-0.3-0.1-0.9-0.3-2-0.5c-1.3-0.3-2.2-0.7-2.8-1.2 c-0.7-0.7-1.1-1.5-1.1-2.4c0-0.6,0.2-1.2,0.5-1.7c0.4-0.5,0.9-1,1.5-1.2s1.5-0.4,2.4-0.4c1.5,0,2.7,0.3,3.4,1 c0.8,0.7,1.2,1.6,1.2,2.7L38,21c-0.1-0.6-0.3-1.1-0.7-1.3c-0.3-0.3-0.9-0.4-1.6-0.4c-0.7,0-1.3,0.1-1.7,0.4 c-0.3,0.2-0.4,0.4-0.4,0.8c0,0.3,0.1,0.5,0.4,0.7c0.3,0.3,1.1,0.5,2.3,0.8s2.1,0.6,2.7,0.9c0.6,0.3,1,0.7,1.3,1.2 c0.3,0.5,0.5,1.2,0.5,1.9c0,0.7-0.2,1.4-0.6,2c-0.4,0.6-0.9,1.1-1.6,1.4c-0.7,0.3-1.6,0.4-2.6,0.4c-1.5,0-2.7-0.4-3.5-1.1 C31.6,28,31.1,27,30.9,25.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbs);
export default __webpack_public_path__ + "static/media/ebs.3dff7298496f5136797c9511478a2777.svg";
export { ForwardRef as ReactComponent };